var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBounty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10352_8521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.964844,
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10352_8521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37492 11.5898H5.20825C5.03117 11.5898 4.88273 11.5299 4.76294 11.4101C4.64315 11.2902 4.58325 11.1417 4.58325 10.9646C4.58325 10.7874 4.64315 10.639 4.76294 10.5194C4.88273 10.3997 5.03117 10.3399 5.20825 10.3399H9.37492V6.17322C9.37492 5.99613 9.43484 5.8477 9.55467 5.72791C9.67452 5.60811 9.82302 5.54822 10.0002 5.54822C10.1773 5.54822 10.3257 5.60811 10.4454 5.72791C10.5651 5.8477 10.6249 5.99613 10.6249 6.17322V10.3399H14.7915C14.9686 10.3399 15.1171 10.3998 15.2369 10.5196C15.3566 10.6395 15.4165 10.788 15.4165 10.9651C15.4165 11.1423 15.3566 11.2907 15.2369 11.4104C15.1171 11.53 14.9686 11.5898 14.7915 11.5898H10.6249V15.7565C10.6249 15.9336 10.565 16.082 10.4451 16.2018C10.3253 16.3216 10.1768 16.3815 9.99963 16.3815C9.82246 16.3815 9.67405 16.3216 9.5544 16.2018C9.43475 16.082 9.37492 15.9336 9.37492 15.7565V11.5898Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBounty);
export default __webpack_public_path__ + "static/media/addBounty.54c79a81511865ba5723db0ba09b51b6.svg";
export { ForwardRef as ReactComponent };